export const RRQRCodePrefix = 'RRQR-';
export const RRQrCodeReturnTypeGlobalProject = RRQRCodePrefix+'PROJ';